// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button class=\"brec-flat-btn brec-pdf-viewer__close-btn\" data-close=\"used in tests\" title=\""
    + container.escapeExpression((lookupProperty(helpers,"i18n")||(depth0 && lookupProperty(depth0,"i18n"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"pdfviewer.modal.close",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":91},"end":{"line":1,"column":123}}}))
    + "\">\n  <span class=\"icon-remove\"></span>\n</button>\n<section inject=\"pdf-viewer\"></section>\n";
},"useData":true});
